import React, { useEffect, useState } from "react";
import AppRouter from "./AppRouter";
import { RecoilRoot } from 'recoil';
import { v4 as uuidv4 } from 'uuid';
import { ToastContainer } from 'react-toastify';
import { axiosClient } from "./services/axiosClient";
import { refreshToken, verifyAuth } from "./services/api";
import { setJWTHeader } from "./services/common";

function App() {
  useEffect(() => {
    if(localStorage.getItem('theme') == 'light'){
      document.documentElement.classList.remove("dark")
    }
    if (!localStorage.getItem('user')) {
      localStorage.setItem('user', uuidv4());
    }
    axiosClient.setHeader('user', localStorage.getItem('user')!);
    if (localStorage.getItem('access_token')) {
      setJWTHeader()

      const currentTime = Math.floor(Date.now() / 1000);
      if ('expires_at' in localStorage) {
        const expiresAt = parseInt(localStorage.getItem('expires_at')!);
        if (expiresAt < currentTime) {
          refreshToken()
        }
      }

      verifyAuth()
    }
  }, []);

  console.log(process.env.REACT_APP_FIREBASE_API_KEY)
  console.log(process.env.REACT_APP_FIREBASE_AUTH_DOMAIN)
  console.log(process.env.REACT_APP_BACKEND_HOST)
  console.log(process.env.REACT_APP_FIREBASE_PROJECT_ID)
  console.log(process.env.REACT_APP_FIREBASE_APP_ID)

  return (
    <div className="h-screen bg-regular">
      <RecoilRoot>
        <ToastContainer />
        <AppRouter />
      </RecoilRoot>
    </div>
  );
}

export default App;